const constants = {
  borderRadius: '2px',
  borderWidth: '1px'
}

export {constants as default}


// WEBPACK FOOTER //
// ./assets/common/theme/constants.js